import { Component, Input, OnInit } from '@angular/core';
import { translate } from '@jsverse/transloco';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { MatDialog } from '@angular/material/dialog';
import { InstallSpecDialogComponent } from '../install-spec-dialog/install-spec-dialog.component';

@Component({
    selector: 'app-solution-version-details',
    templateUrl: './solution-version-details.component.html',
    styleUrls: ['./solution-version-details.component.scss'],
    standalone: false
})
export class SolutionVersionDetailsComponent implements OnInit {

  @Input() data;

  title: string;
  capabilities: any = {};
  displayedColumns = ['name', 'version'];

  constructor(public dateTimeFormatService: DateTimeFormatService, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.title = translate('SOLUTIONS.SOLUTION');
    this.capabilities.mandatory = this.data?.capabilities?.filter(capability => capability.required === 'mandatory');
    this.capabilities.optional = this.data?.capabilities?.filter(capability => capability.required === 'optional');
  }

  onClick(installSpec): void {
    this.dialog.open(InstallSpecDialogComponent, {
      minHeight: '342px',
      width: '630px',
      panelClass: 'flex-dialog',
      data: {
        title:  translate('SOLUTIONS.INSTALLATION_SPECIFICATION'),
        description: installSpec
      }
    });
  }

  onClickSandbox(installSpec): void {
    this.dialog.open(InstallSpecDialogComponent, {
      minHeight: '342px',
      width: '630px',
      panelClass: 'flex-dialog',
      data: {
        title:  translate('SOLUTIONS.SANDBOX_SPECIFICATION'),
        description: installSpec
      }
    });
  }

}
